

export const buildOutlookCalendarUrl = (task, eventDate, responsibleUserName) => {
    const body = buildEncodedBody(task, false, responsibleUserName);
    return "https://outlook.office.com/owa/?path=/calendar/action/compose&subject=" + task.name + "&body=" + body + "&startdt=" + eventDate + "&enddt=" + eventDate;
}

export const buildGoogleCalendarURL = (task, eventDate, responsibleUserName) => {
    const body = buildEncodedBody(task, true, responsibleUserName);
    return "https://calendar.google.com/calendar/render?action=TEMPLATE&text=" + task.name + "&details=" + body + "&dates=" + eventDate + "/" + eventDate;
}

export const buildMailToUrl = (task, responsibleUserName) => {
    const body = buildEncodedBody(task, false, responsibleUserName);
    return "mailto:?subject=" + task.name + "&body=" + body;
}

export const buildOutlookCalendarICSFile = (task, eventDate, responsibleUserName) => {
    let url = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "BEGIN:VEVENT",
        "SUMMARY:" + task.name,
        "DESCRIPTION:" + buildICSBody(task, responsibleUserName),
        "DTSTART:" + eventDate,
        "DTEND:" + eventDate,
        "END:VEVENT",
        "END:VCALENDAR"
    ].join("\n");
    return url;
}

const buildEncodedBody = (task, isHtml, responsibleUserName) => {
    let br = (isHtml) ? encodeURIComponent("<br />") : encodeURIComponent(" \r\n");

    // [Milestone] The Task name
    let body = task.isMilestone ? encodeURIComponent("[Milestone] - ") : "Task Name: ";
    body += encodeURIComponent(task.name) + br;

    body += "Responsible User: " + encodeURIComponent(responsibleUserName) + br;
    body += "Additional Info: " + encodeURIComponent(task.additionalInfo) + br;
    body += "Target Date: " + encodeURIComponent(task.targetDate) + br;
    body += "Contact Info: " + encodeURIComponent(task.contactName) + br;
    body += "Contact Name: " + encodeURIComponent(task.contactEmail) + br;

    if(task.startDate){
        body += "Start Date: " + encodeURIComponent(task.startDate) + br;
    }
    
    if(task.projectName){
        body += "Project Name: " + encodeURIComponent(task.projectName) + br;
    }

    if(task.jobTitleName){
        body += "Suggested Responsible: " + encodeURIComponent(task.jobTitleName) + br;
    }

    if(task.links && task.links.length > 0){
        for(let i = 0; i < task.links.length; i++){
            if(isHtml){
                body += encodeURIComponent('<a href="' + task.links[i].url + '" target="_blank">' + task.links[i].name + '</a><br />');
            }else{
                body += encodeURIComponent(task.links[i].url) + br;
            }
        }
    }

    body += br;
    let taskListUrl = window.location.origin + "/tasks?t=" + task.id;
    if(isHtml){
        body += encodeURIComponent('<a href="' + taskListUrl + '" target="_blank">' + taskListUrl + '</a><br />');
    }else{
        body += encodeURIComponent(taskListUrl);
    }
    

    return body;
}

const buildICSBody = (task, responsibleUserName) => {
    let br = " <br />";

    let body = task.isMilestone ? "[Milestone] - " : "Task Name: ";
    body += task.name + br;

    body += "Responsible User: " + responsibleUserName + br;
    body += "Additional Info: " + task.additionalInfo + br;
    body += "Target Date: " + task.targetDate + br;
    body += "Contact Info: " + task.contactName + br;
    body += "Contact Name: " + task.contactEmail + br;

    if(task.startDate){
        body += "Start Date: " + task.startDate + br;
    }
    
    if(task.projectName){
        body += "Project Name: " + task.projectName + br;
    }

    if(task.jobTitleName){
        body += "Suggested Responsible: " + task.jobTitleName + br;
    }

    if(task.links && task.links.length > 0){
        for(let i = 0; i < task.links.length; i++){
            body += task.links[i].url + br;
        }
    }
    return body;
}